export default __webpack_public_path__ + "static/media/Fellix-Bold.997e1e3b.woff2";